class ProductsListTabs extends HTMLElement {
  constructor() {
    super();

    this.tabs = this.querySelectorAll('.products-list-tabs__tab');
    this.cards = this.querySelectorAll('.products-list-tabs__card, .w-product-card[data-tab-id]');
    this.addToCartButtons = this.querySelectorAll('.products-list-tabs__add-to-cart, .w-product-card__add-to-cart');

    this.init();
    this.initAddToCart();
  }

  init() {
    if (!this.tabs.length) return;

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', this.handleTabClick.bind(this));
      tab.addEventListener('keydown', this.handleTabKeydown.bind(this));
    });

    if (Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', () => {
        this.tabs = this.querySelectorAll('.products-list-tabs__tab');
        this.cards = this.querySelectorAll('.products-list-tabs__card, .w-product-card[data-tab-id]');
        this.init();
      });
    }
  }

  handleTabClick(event) {
    const clickedTab = event.currentTarget;
    const targetTabId = clickedTab.dataset.tabId;

    this.switchTab(clickedTab, targetTabId);
  }

  handleTabKeydown(event) {
    const { key } = event;
    const currentTab = event.currentTarget;
    const tabsArray = Array.from(this.tabs);
    const currentIndex = tabsArray.indexOf(currentTab);

    let nextIndex;

    switch (key) {
      case 'ArrowLeft':
        event.preventDefault();
        nextIndex = currentIndex === 0 ? tabsArray.length - 1 : currentIndex - 1;
        tabsArray[nextIndex].focus();
        tabsArray[nextIndex].click();
        break;
      case 'ArrowRight':
        event.preventDefault();
        nextIndex = currentIndex === tabsArray.length - 1 ? 0 : currentIndex + 1;
        tabsArray[nextIndex].focus();
        tabsArray[nextIndex].click();
        break;
      case 'Home':
        event.preventDefault();
        tabsArray[0].focus();
        tabsArray[0].click();
        break;
      case 'End':
        event.preventDefault();
        tabsArray[tabsArray.length - 1].focus();
        tabsArray[tabsArray.length - 1].click();
        break;
    }
  }

  switchTab(selectedTab, targetTabId) {
    this.tabs.forEach((tab) => {
      const isSelected = tab === selectedTab;
      tab.classList.toggle('products-list-tabs__tab--active', isSelected);
      tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
    });

    this.cards.forEach((card) => {
      const cardTabId = card.dataset.tabId;
      if (cardTabId === targetTabId) {
        card.hidden = false;
      } else {
        card.hidden = true;
      }
    });
  }

  initAddToCart() {
    this.addToCartButtons.forEach(button => {
      button.addEventListener('click', async (e) => {
        e.preventDefault();

        const variantId = button.dataset.variantId;
        if (!variantId) return;

        button.classList.add('loading');
        button.disabled = true;

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 1
            })
          });

          if (!response.ok) throw new Error('Failed to add to cart');

          document.dispatchEvent(new CustomEvent('cart:refresh'));

          button.classList.remove('loading');
          button.classList.add('success');

          setTimeout(() => {
            button.classList.remove('success');
            button.disabled = false;
          }, 2000);

        } catch (error) {
          console.error('Error adding to cart:', error);
          button.classList.remove('loading');
          button.disabled = false;
        }
      });
    });
  }
}

if (!customElements.get('products-list-tabs')) {
  customElements.define('products-list-tabs', ProductsListTabs);
}
